import React from 'react';

import TotalPrice from './TotalPrice';
import Preview from './Preview';
import Presets from './Presets';
import { withTranslation } from 'react-i18next';

const Overview = ({t}) => {
  return (
    <div className="custom-glove-preview-wrap">
      <div className="custom-glove-sticky-wrap">
        <TotalPrice />
        <Preview />
      </div>
      <Presets />
      <p
        className="custom-glove-info-link"
        style={{
          width: '100%',
          maxWidth: 940,
          margin: 'auto',
          marginTop: 56,
          color: 'red',
          padding: '0 20px',
          boxSizing: 'border-box',
        }}
      >
        <strong
          role="button"
          tabIndex="-1"
          onClick={() =>
            window.open('https://docs.google.com/document/d/19uq7oipcMk04d46Ggw6E3bMc1lMHdmZ_K7flQjLdIbE')
          }
          style={{
            fontWeight: 'bold',
            color: 'blue',
            fontStyle: 'italic',
            cursor: 'pointer',
          }}
        >
          {t('findForMe')}
        </strong>{' '}
      </p>

      <p
        className="custom-glove-info-link"
        style={{
          width: '100%',
          maxWidth: 940,
          margin: 'auto',
          marginTop: 10,
          color: 'red',
          padding: '0 20px',
          boxSizing: 'border-box',
        }}
      >
        <strong
          role="button"
          tabIndex="-1"
          onClick={() =>
            window.open('https://gloveworks.link')
          }
          style={{
            fontWeight: 'bold',
            color: 'blue',
            fontStyle: 'italic',
            cursor: 'pointer',
          }}
        >
          {t('builderProvides')}
        </strong>{' '}
      </p>
    </div>
  );
}

export default (withTranslation()(Overview));